module.exports = __webpack_public_path__ + "static/media/program-ziua.83fd1a5d.svg";